import I18n from 'I18n';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PlayPauseToggle = ({
  initialOn = false,
  onToggle
}) => {
  const [on, setOn] = useState(initialOn);
  const toggle = () => {
    const newState = !on;
    setOn(newState);
    onToggle();
  };
  return /*#__PURE__*/_jsx("button", {
    onClick: toggle,
    className: "vjs-autoplay-toggle-container",
    title: on ? I18n.text('videoPlayer.controls.autoplay.on') : I18n.text('videoPlayer.controls.autoplay.off'),
    children: /*#__PURE__*/_jsx("span", {
      className: "vjs-autoplay-icon vjs-icon-placeholder",
      style: {
        backgroundColor: !on ? 'black' : 'white',
        color: !on ? 'white' : 'black',
        transform: on ? 'translateX(16px)' : 'translateX(0px)',
        transition: 'transform 0.2s ease, background-color 0.2s ease, color 0.2s ease'
      },
      children: !on ? /*#__PURE__*/_jsx("span", {
        className: "vjs-icon-pause"
      }) : /*#__PURE__*/_jsx("span", {
        className: "vjs-icon-play"
      })
    })
  });
};
export default PlayPauseToggle;